import useReviewCreationModal from 'hooks/useReviewCreationModal'
import { useEffect } from 'react'
import { useCommandLine } from 'hooks/useCommandLine'

export const useReviewCreateShortcut = () => {
  const { openReviewModal } = useReviewCreationModal()
  const { addContext, removeContext } = useCommandLine()

  useEffect(() => {
    addContext('openNewReviewModal', openReviewModal)

    return () => removeContext('openNewReviewModal')
  }, [addContext, removeContext, openReviewModal])
}
